import React from 'react';
import classNames from 'classnames';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {default as ReactDatePicker} from 'react-datepicker';
import {Input, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {convertToFnsFormat, getFnsLocale, getLang, getLocale} from '../../../../Localization';
import {isInputDate} from '../../../library/utils/date';
import {formatStringToDate} from '../../../../features/Form/utils/date';
import {getRawDate, isValid} from '@priority-software/priority-utils/lib/date';
import {keys} from '../../../../constants/KeyCodes';
@observer
export default class DatePicker extends Component<any, any> {
    calendar;
    fakeCalendar;
    local;
    dateTime;
    currentInputValue;

    static defaultProps = {
        showPopperArrow: true
    };

    constructor(props) {
        super(props);
        this.local = getLocale();
        this.fakeCalendar = React.createRef();
    }

    componentDidUpdate() {
        this.fakeCalendar.current && this.fakeCalendar.current.focus();
    }

    onChange = (newDate: Date | string) => {
        this.props.onChange?.(newDate);
    };

    fakeChange = e => {
        const {dateFormat} = this.props;
        const value = e.target.value;
        if (isValid(value, dateFormat)) {
            const newValue = getRawDate(this.props.selected, value, dateFormat);
            this.onChange(newValue);
        }
    };

    faceBlur = e => {
        const {dateFormat, onChange, onBlur} = this.props;
        const value = e.target.value;
        if (value && value !== 'NULL' && value.length < dateFormat.length) {
            const completes = dateFormat
                .substring(value.length, dateFormat.length)
                .replace(new RegExp(/([a-z]|[A-Z])/g), '*');
            const newDate = value + completes;
            onChange && onChange(newDate);
        }
        onBlur && onBlur();
    };

    setCalendarOpen = e => {
        const {open, setOpen} = this.props;
        if (typeof open === 'boolean' && setOpen) {
            setOpen(true);
        } else {
            this.calendar.setOpen(true);
        }
    };

    dateRawChange = e => {
        const value = e.target.value;
        const {dateFormat} = this.props;
        if (typeof value === 'string') {
            if (isValid(value, dateFormat)) {
                const newValue = getRawDate(
                    this.currentInputValue || '',
                    value,
                    dateFormat,
                    this.props.showTimeSelect
                );
                this.currentInputValue = newValue;
                e.currentTarget.value = newValue;
                if (isInputDate(newValue)) {
                    this.onChange(newValue);
                }
            } else {
                e.preventDefault();
            }
        }
    };

    handleKeyDown = e => {
        const {key} = e;
        if (key === keys.TAB) {
            this.calendar.setOpen(false);
        }
    };

    render() {
        const {
            dateFormat,
            startDate,
            endDate,
            selectsStart,
            selectsEnd,
            calendarClassName,
            showTimeSelect,
            timeFormat,
            className = '',
            triggerIconClassName = '',
            autoFocus,
            selected,
            hideDisableIcon,
            ...otherDatePickerProps
        } = this.props;

        if (isInputDate(selected)) {
            const classes = classNames('fake-input', className);

            return (
                <div className="fake">
                    <Input
                        autoFocus={autoFocus}
                        inputRef={this.props.fakeCalendarRef || this.fakeCalendar}
                        value={this.props.selected}
                        componentClasses={classes}
                        onChange={event => this.fakeChange(event)}
                        onBlur={this.faceBlur}
                    >
                        {!hideDisableIcon && <Icon icon={PriorityIcon.calendar} disabled />}
                    </Input>
                </div>
            );
        } else {
            const classes = classNames('date-picker-input', className);
            return (
                <div>
                    <ReactDatePicker
                        {...otherDatePickerProps}
                        ref={c => {
                            this.calendar = c;
                        }}
                        autoFocus={autoFocus}
                        locale={getFnsLocale(getLang())}
                        dateFormat={convertToFnsFormat(dateFormat)}
                        selected={
                            selected && formatStringToDate(selected, showTimeSelect, getLang())
                        }
                        selectsStart={selectsStart}
                        selectsEnd={selectsEnd}
                        startDate={
                            startDate && formatStringToDate(startDate, showTimeSelect, getLang())
                        }
                        endDate={endDate && formatStringToDate(endDate, showTimeSelect, getLang())}
                        minDate={
                            selectsEnd && startDate
                                ? formatStringToDate(startDate, showTimeSelect, getLang())
                                : null
                        }
                        onChangeRaw={this.dateRawChange}
                        onChange={this.onChange}
                        calendarClassName={calendarClassName}
                        className={classes}
                        showTimeSelect={showTimeSelect}
                        timeIntervals={15}
                        timeFormat={timeFormat}
                        onKeyDown={this.handleKeyDown}
                    />
                    <div className={triggerIconClassName} onClick={this.setCalendarOpen}>
                        <Icon
                            icon={PriorityIcon.calendar}
                            skin="standart"
                            componentClasses="date-icon"
                        />
                    </div>
                </div>
            );
        }
    }
}
